import { render, staticRenderFns } from "./editCube14.vue?vue&type=template&id=2b8b0d56&scoped=true&"
import script from "./editCube14.vue?vue&type=script&lang=js&"
export * from "./editCube14.vue?vue&type=script&lang=js&"
import style0 from "./editCube14.vue?vue&type=style&index=0&id=2b8b0d56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b0d56",
  null
  
)

export default component.exports